import React, { useRef } from 'react';
import { ISearchAvailRoom } from '@entities/search-avail-room';
import { Carousel, Button, Tooltip, Skeleton } from 'antd';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { IImage } from '@src/store/entities/image';
import { IInfrastructure } from '@src/store/entities/infrastructure';
import './category-vars.css';
import { CarouselRef } from 'antd/es/carousel';

// Карточка категории в поиске доступных категорий
const CategoryVars = ({ ...props }) => {
    const { category, items, bestPrice, selected, onSelectCategory, images, infras, id, hasChoice } = props;
    const ref = useRef<CarouselRef>(null);
    let divMen = [];
    for (let i = 0; i < category.countMainBeds; i++) divMen.push(<img src='/images/man.png' alt='' key={`m${i}`} />);
    if (category.countExtraBeds > 0) {
        divMen.push(<img src='/images/plus.png' alt='' key={'p'} />);
        for (let i = 0; i < category.countExtraBeds; i++) divMen.push(<img src='/images/man.png' alt='' key={`e${i}`} />);
    }
    const seatHint = `Основных мест - ${category.countMainBeds}` + (category.countExtraBeds > 0 ? `, доп. ${category.countExtraBeds}` : '');
    const hasDiscount = items.find((e: ISearchAvailRoom) => e.amount != e.amountWithDiscount) != null;
    const divBadges = (
        <div className='category-vars-badges'>
            {hasDiscount && <span className='category-vars-badge category-vars-badge-sale'>Скидка</span>}
            {bestPrice && <span className='category-vars-badge category-vars-badge-best'>Лучшая цена</span>}
            {category.qtyRest == 1 && <span className='category-vars-badge category-vars-badge-last'>Остался 1 номер</span>}
            {category.qtyRest == 2 && <span className='category-vars-badge category-vars-badge-last'>Осталось 2 номера</span>}
            {category.salesLeader && <span className='category-vars-badge category-vars-badge-lead'>Лидер продаж</span>}
        </div>
    );
    const visibleInfras = (infras || []).slice(0, 8);
    const extraInfraCount = Math.max(0, (infras?.length || 0) - visibleInfras.length);
    const divInfra = visibleInfras.length > 0 && (
        <div className='category-vars-category-infra'>
            {visibleInfras.map((e: IInfrastructure) => (
                <Tooltip title={e.name} key={e.infrastructureID}>
                    <span className='category-vars-infra-item'>
                        <img src={`${process.env.REACT_APP_API_BASE_URL}/api/image${e.imageFileName}`} alt={e.name} />
                    </span>
                </Tooltip>
            ))}
            {extraInfraCount > 0 && <span className='category-vars-infra-more'>+{extraInfraCount}</span>}
        </div>
    )
    const divNoDiscount =
        category.amount == category.amountWithDiscount ? null : (
            <div className='category-vars-category-bottom-red'>{category.amount.toLocaleString('ru-RU')} ₽</div>
        );
    const divBottom = (
        <div className='category-vars-category-bottom'>
            {category.amount > 0 ? (
                <div className='category-vars-category-bottom-price'>
                    {divNoDiscount}
                    <div className='category-vars-price-current'>
                        {hasChoice ? <span className='category-vars-price-from'>от</span> : null}
                        {`${category.amountWithDiscount.toLocaleString('ru-RU')} ₽`}
                    </div>
                </div>
            ) : <div className='category-vars-price-empty'>Нет цены на даты</div>}
            <Button
                className={'category-vars-category-bottom-btn' + (items.length == 0 ? ' width-100-prc' : '')}
                onClick={() => onSelectCategory(category.roomCategoryId)}
            >
                {items.length == 0 ? 'Доступные даты' : 'Забронировать'}
            </Button>
        </div>
    )
    const SlickArrowLeft = () => <Button aria-hidden='true' shape='circle' icon={<LeftOutlined />} className="slick-arrow slick-prev" onClick={() => ref.current?.prev()}/>
    const SlickArrowRight = () => <Button aria-hidden='true' shape='circle' icon={<RightOutlined />} className="slick-arrow slick-next" onClick={() => ref.current?.next()}/>
    return <div className={`category-vars-container${selected ? ' category-vars-container-selected' : ''}`} id={id}>
            <div className='category-vars-category-img'>
                {images.length == 0 ? <Skeleton.Image active className='category-vars-skeleton' /> : <Carousel arrows={true} prevArrow={<SlickArrowLeft />} nextArrow={<SlickArrowRight />} slidesToScroll={1} ref={ref}>
                        {images.map((i: IImage) => {
                            const fileName = i.imageFileName ? `${process.env.REACT_APP_API_BASE_URL}/api/image${i.imageFileName}` : i.source;
                            return <div key={i.imageId}>
                                    <div className='category-vars-image'>
                                        <img src={fileName} alt={category.name} />
                                    </div>
                                </div>
                        })}
                    </Carousel>
                }
                {divBadges}
            </div>
            <div className='category-vars-content'>
                <div>
                    <div className='category-vars-category-title'>
                        <span className='category-vars-category-name'>{category.name}</span>
                        <span className='category-vars-title-meta'>
                            <Tooltip title={seatHint}><span className='category-vars-seats'>{divMen}</span></Tooltip>
                        </span>
                    </div>
                    {category.description && <div className='category-vars-category-description'>{category.description}</div>}
                    {divInfra}
                </div>
                {selected ? null : divBottom}
            </div>
        </div>
};

export default CategoryVars;
